export enum DynamicsRequestTypeEnum {
  NEW = 'new',
  NEW_SAVED = 'new_saved',
  REDIRECT = 'redirect',
  SAVED = 'saved',
}
